module.exports = __webpack_public_path__ + "static/media/logo.7451f65b.png";